<!-- scheduler.component.html -->

<div class="container mt-3">
  <table class="table">
    <!-- Header con giorni in orizzontale -->
    <thead>
      <tr>
        <th></th>
        <th *ngFor="let day of daysOfWeek">{{ day }}</th>
      </tr>
    </thead>

    <!-- Corpo con orari in verticale -->
    <tbody>
      <ng-container *ngFor="let i of hoursOfDay; let idx = index">
        <tr>
          <td class="hour-cell" *ngIf="idx % 4 === 0" [attr.rowspan]="4">{{ i }}</td>
          <td class="cell" *ngFor="let day of daysOfWeek" [class.offset]="idx % 4 === 0" (click)="addEvent(i, day)">
            <!-- Aggiungi qui la logica per gli eventi o le attività per ogni giorno e ora -->
            <div class="text-center">
              <ng-container *ngFor="let event of events[day + '_' + i]; let idx = index">
                <div  class="event p-1 mb-1" [class.active]="event.test === test?.name" [nbTooltip]="event.test || ''"
                  style="background-color: {{getColor(event.test)}};">
                  <i class="del far fa-times-circle" (click)="removeEvent($event, day + '_' + i, idx)"></i>
                </div>
              </ng-container>

            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
